/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExpecterdDepartureArrival = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2h14v4h-2V4H7v2H5zm6 6H9V6h2zm4 0h-2V6h2zM3.086 11.5 1.293 9.707l1.414-1.414L5.914 11.5l-3.207 3.207-1.414-1.414zm17 0-1.793-1.793 1.414-1.414 3.207 3.207-3.207 3.207-1.414-1.414zM11 12H9v-2h2zm4 0h-2v-2h2zm-6 2h6v6h2v-3h2v5H5v-5h2v3h2zm2 6h2v-4h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExpecterdDepartureArrival as ExpecterdDepartureArrival };
